module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Snowfall-S2.7996776.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Snowfall-S2.jpg
// module id = ETxM
// module chunks = 0